import farmWork from "./farmWork";
import wisdomSupport from "./wisdomSupport";
import standard from "./standard";
import gap from "./gap";
import fileType from "./fileType";
import popularScience from "./popularScience";
import expertInfo from "./expertInfo";
import systemManage from "./systemManage";

export default [
    farmWork,
    wisdomSupport,
    standard,
    gap,
    fileType,
    popularScience,
    expertInfo,
    systemManage
];